import styled from '@emotion/styled';
import { createBasicColorSet, cssColorSet } from '@spotify-internal/encore-web';

const AddMusicIconWrapper = styled.div`
  width: 30px;
  height: 24px;
`;

const MenuItemIconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 18px;
  height: 18px;
  margin-right: 28px;
`;

const BackgroundMusicIconWrapper = styled.div`
  width: 14px;
  height: 14px;
  padding-left: 4px;
  transform: translateY(-28px);
`;

/** Takes a foreground and background color. Returns a color set object . */
const SpinnerCustomColor = createBasicColorSet('#000000', '#000000');
/** Takes a color set object. Returns a set of semantic CSS variables. */
const cssCustomColorSet = cssColorSet(SpinnerCustomColor);

type ButtonWrapperProps = { backgroundColor: string; cssCustomColorSet: any };
const ButtonWrapper = styled.button<ButtonWrapperProps>`
  ${cssCustomColorSet}
  height: 50px;
  width: 50px;
  display: grid;
  place-content: center;
  border-radius: 100%;
  flex: 0 0 50px;
  padding: 14px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  > *,
  svg {
    height: 100%;
  }
`;

export const StopButton = styled.div<{ iconSize?: number }>`
  width: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '10px')};
  height: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '10px')};
  background-color: #fff;
`;

export {
  AddMusicIconWrapper,
  MenuItemIconWrapper,
  BackgroundMusicIconWrapper,
  ButtonWrapper,
};

export const CancelButton = styled.button`
  display: block;
  margin: 24px auto 0 auto;
  padding: 0;
  border: 0;
  color: #5f6369;
  font-weight: bold;
  font-size: 1rem;
  &:focus {
    color: #292f36;
  }
`;
